import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { useUserData } from '../../../context/UserDataContext/UserDataContext';
import { WixStudioLogo } from '../WixStudioLogo/WixStudioLogo';
import Desktop from './Desktop.svg';

import s from './MobileWixStudioToolbar.scss';

export const MobileWixStudioToolbar: FC<{ dataHook?: string }> = ({ dataHook }) => {
  const { t } = useTranslation();
  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);
  const userData = useUserData();

  const onButtonClick = () => {
    if (!redirectUrl) {
      return;
    }
    const url = encodeURIComponent(redirectUrl);
    const anonUrl = `https://users.wix.com/signin/signup/password?studio=true&loginDialogContext=signup&loginCompName=SignUp_H&postSignUp=${url}&postLogin=${url}&forceRender=true`;
    window.location.href = userData.isLoggedIn ? redirectUrl : anonUrl;
  };

  useEffect(() => {
    const url = new URL(window.location.toString()).searchParams.get('redirectUrl');
    if (url) {
      const urlObj = new URL(url);
      if (urlObj.host === 'www.wix.com') {
        setRedirectUrl(url);
      }
    }
  }, []);

  return (
    <>
      <div className={s.toolbar} data-hook={dataHook}>
        <WixStudioLogo />
        {redirectUrl && (
          <button onClick={onButtonClick} className={s.button}>
            {t('template.viewer.saveTemplate.button')}
          </button>
        )}
      </div>
      <div className={s.goToDesktop}>
        <Desktop />
        <div>{t('template.viewer.goToBiggerScreen')}</div>
      </div>
    </>
  );
};
